import React from 'react';
import { Link } from 'react-router-dom';

const Archivebox = ({archiveData}) => {
    return (
        <>
        {archiveData.map((archiveD)=>(
        <div className='w-full md:w-1/3 h-full my-7 flex justify-start items-start text-center grayscale hover:grayscale-0 transition-all ease-in-out duration-100'>                            
            <div className='flex flex-col w-4/5 ml-auto relative'>
                <div class="absolute left-0 top-0 -mt-3 h-96 w-full -translate-x-3 -rotate-3 rounded-xl bg-gray-300 z-10 box-shadow"></div>
                <div class="absolute left-0 top-0 -mt-5 h-96 w-full -translate-x-5 -rotate-[5deg] rounded-xl bg-gray-200 z-[5] box-shadow"></div>
                <div class="absolute left-0 top-0 -mt-6 h-96 w-full -translate-x-7 -rotate-[7deg] rounded-xl bg-gray-100 z-0 box-shadow"></div>
                <Link to={archiveD.to} className='flex w-full h-96 overflow-hidden rounded-xl box-shadow hover:shadow-2xl bg-slate-500 z-30 border borde-solid border-gray-200'>
                    <div className='w-full h-full bg-no-repeat bg-cover bg-center' style={{backgroundImage:`url(${archiveD.image})`}}></div>
                </Link>
                <Link to={archiveD.to} className='my-1 py-3 rounded-xl bg-gray-200 text-center font-semibold hover:bg-slate-700 hover:text-white transition-all ease-in-out duration-200'>{archiveD.title}</Link>
            </div>
        </div>
        )
        )}
        </>
    );
}

export default Archivebox;